import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

export const createNote = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/note/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// calculer la moyenne total d'un étudiant
export const calculateAverage = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/note/calculate`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// calculer la moyenne par matière
export const getSubjectAverages = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/note/calculate/subject`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// calculer la moyenne par niveau
export const calculateAveragesLevel = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/note/calculate/level`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// calculer la moyenne par semestre ou période d'évaluation
export const getAverageByPeriod = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/note/calculate/semestre`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

//Afficher les notes en fonction de la classe de l'anne et de l'etudiant pour les pdf
export const studentNotePdf = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/note/student-notes-pdf`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// vérifier l'éligibilité d'un étudiant
export const checkStudentEligibility = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/note/check`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const reCheckStudentEligibility = async (id, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/note/check/decision/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer les notes de l'étudiant
export const getStudentNote = async (id_student, id_academicYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/note/etudiant/${id_student}/${id_academicYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer les notes de l'étudiant en fonction de la matiere
export const getStudentNoteByMatiere = async (
  id_student,
  id_subject,
  id_academicYear,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/note/matiere/${id_student}/${id_subject}/${id_academicYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};
// récupérer les notes de l'étudiant en fonction de l'évaluation
export const getAllStudentNoteByEvaluation = async (
  id_student,
  id_evaluation,
  id_academicYear,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/note/all/${id_student}/${id_evaluation}/${id_academicYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};
// récupérer les notes d'un etudiant en fonction de la  periode d'évaluation
export const getAllStudentNoteByEvaluationPeriod = async (
  id_student,
  id_evaluationPeriode,
  id_academicYear,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/note/periode/${id_student}/${id_evaluationPeriode}/${id_academicYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateStudentNote = async (id_note, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/note/update/${id_note}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getStudentCertificate = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/note/attestation`,
    payload,
    {
      headers: setHeaders(context),

      responseType: "blob",
    },
  );
  return response.data;
};

export const deleteStudentNote = async (id_note, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/note/delete/${id_note}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// --------------------------PDF-------------------------------------------------------

export const generateStudentNoteReleve = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/pdf/generate-releve`,
    payload,
    {
      headers: setHeaders(context),

      responseType: "blob",
    },
  );
  return response.data;
};

export const generateStudentCertificate = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/pdf/generate-attestation`,
    payload,
    {
      headers: setHeaders(context),

      responseType: "blob",
    },
  );
  return response.data;
};

export const generateStudentDiplomeLicence = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/pdf/generate-diplome-licence`,
    payload,
    {
      headers: setHeaders(context),

      responseType: "blob",
    },
  );
  return response.data;
};

export const generateStudentDiplomeMaster = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/pdf/generate-diplome-master`,
    payload,
    {
      headers: setHeaders(context),
      responseType: "blob",
    },
  );
  return response.data;
};

// --------------------------Historique-------------------------------------------------------
export const getAllNoteHistory = async (context) => {
  const response = await axios.get(apiPaths.baseUrl + `/api/NoteHistory/all`, {
    headers: setHeaders(context),
  });
  return response.data;
};

// --------------------------Import/Export-------------------------------------------------------
export const exportNotesByYearAndClasses = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/exporte/note/excel`,
    payload,
    { headers: setHeaders(context), responseType: "blob" },
  );
  return response.data;
};

export const importNote = async (payload) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/importNote`,
    payload,
    {
      headers: { ...setHeaders(), "Content-Type": "multipart/form-data" },
    },
  );
  return response.data;
};

export const templateNote = async (
  classId,
  evaluationPeriodId,
  SubjectUeId,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/download/templateNote/${classId}/${evaluationPeriodId}/${SubjectUeId}`,

    {
      headers: setHeaders(),

      responseType: "blob",
    },
  );
  return response.data;
};

// -------------------Phase 2-------------------------------------------------------
// Générer la fiche de note des étudiants
export const generateNoteFiche = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/pdf/generate-ficheNote`,
    payload,
    {
      headers: setHeaders(context),

      responseType: "blob",
    },
  );
  return response.data;
};

// Phase 3 & 4----------------------------------------------------------------------------------------
export const updateAutorisation = async (
  id_academicYear,
  id_studentProfil,
  payload,
  context,
) => {
  const response = await axios.put(
    apiPaths.baseUrl +
      `/api/note/blocked/${id_academicYear}/${id_studentProfil}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateAutorisationsBatch = async (payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/note/blocked-batch`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const blockStudentsByPlan = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/note/Classblocked`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};
